import { useSelector } from "react-redux";

import { RootState } from "../../../store/store";
import LogoSpinner from "./LogoSpinner";

interface IProps
{
  /** Diameter of the spinner; shrink it inside small boxes (thumbnails). */
  size?: number;
}

/**
 * Full-area loading overlay: dims whatever is behind it and centres the shared
 * LogoSpinner on top. The dimming lives on its own layer so the logo stays
 * crisp instead of fading with the backdrop.
 */
const LoadingGlobalComp = ({ size = 48 }: IProps) =>
{
  const colorConfig = useSelector(
    (state: RootState) => state.appCommonSlice.colorConfig
  );

  return (
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-full w-full flex items-center justify-center"
      style={{ zIndex: 999999 }}
    >
      <div
        className="absolute inset-0"
        style={{ background: colorConfig?.loading?.background, opacity: 0.7 }}
      />
      <LogoSpinner size={size} />
    </div>
  );
};

export default LoadingGlobalComp;
